import React, { useEffect, useRef } from "react";
import { createChart } from "lightweight-charts";

const ChartComponent = ({ data }) => {

   

  const chartContainerRef = useRef();
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartContainerRef.current || !data.length) return;

    // Initialize chart with dark theme
    const chart = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: chartContainerRef.current.clientHeight, // Use full container height
      layout: {
        background: { type: "solid", color: "#0a0a0a" }, // slate-900
        textColor: "#94a3b8", // slate-400
      },
      grid: { 
        vertLines: { color: "#1e293b" }, // slate-800
        horzLines: { color: "#1e293b" }  // slate-800
      },
      timeScale: { 
        timeVisible: true, 
        secondsVisible: true, // Show seconds for RAW data
        borderColor: "#475569" // slate-600
      },
      rightPriceScale: { 
        borderColor: "#475569" // slate-600
      },
    });

    chartRef.current = chart;
    const series = chart.addCandlestickSeries({
      upColor: "#26a69a",    // teal-500
      downColor: "#ef5350",  // red-500
      wickUpColor: "#26a69a",
      wickDownColor: "#ef5350",
      borderVisible: false,
    });

    // Format data for Lightweight Charts
    // const formattedData = data.map(d => ({
    //   time: new Date(d.datetime).getTime() / 1000, // Convert to UNIX timestamp
    //   open: d.open,
    //   high: d.high,
    //   low: d.low,
    //   close: d.close
    // }));
    const formattedData = data.map(d => {
      const dateUTC = new Date(d.datetime); // original UTC or local date
      const offsetIST = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
      const dateIST = new Date(dateUTC.getTime() + offsetIST); // adjust to IST
      return {
        time: Math.floor(dateIST.getTime() / 1000), // UNIX timestamp in seconds
        open: d.open,
        high: d.high,
        low: d.low,
        close: d.close
      };
    });
    

    series.setData(formattedData);
    chart.timeScale().fitContent();

    // Handle resize
    const handleResize = () => {
      if (chartRef.current && chartContainerRef.current) {
        chartRef.current.applyOptions({
          width: chartContainerRef.current.clientWidth,
          height: chartContainerRef.current.clientHeight,
        });
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (chartRef.current) {
        chartRef.current.remove();
        chartRef.current = null;
      }
    };
  }, [data]);

  return (
    <div 
      ref={chartContainerRef} 
      className="w-full h-full"
    />
  );
};

export default ChartComponent;